import React from 'react';

type BadgeVariant =
  | 'open' |'funded' |'under-review' |'closed' |'proposed' |'negotiating' |'launched' |'pending' |'accepted' |'rejected' |'poster' |'entrepreneur' |'investor' |'admin';

const variantMap: Record<BadgeVariant, string> = {
  open: 'bg-success-bg text-success border-success/20',
  funded: 'bg-primary/10 text-primary border-primary/20',
  'under-review': 'bg-warning-bg text-warning border-warning/20',
  closed: 'bg-muted text-muted-foreground border-border',
  proposed: 'bg-info-bg text-info border-info/20',
  negotiating: 'bg-warning-bg text-warning border-warning/20',
  launched: 'bg-success-bg text-success border-success/20',
  pending: 'bg-warning-bg text-warning border-warning/20',
  accepted: 'bg-success-bg text-success border-success/20',
  rejected: 'bg-danger-bg text-danger border-danger/20',
  poster: 'bg-orange-50 text-orange-600 border-orange-200',
  entrepreneur: 'bg-violet-50 text-violet-600 border-violet-200',
  investor: 'bg-primary/10 text-primary border-primary/20',
  admin: 'bg-slate-100 text-slate-600 border-slate-200',
};

const labelMap: Record<BadgeVariant, string> = {
  open: 'Open',
  funded: 'Funded',
  'under-review': 'Under Review',
  closed: 'Closed',
  proposed: 'Proposed',
  negotiating: 'Negotiating',
  launched: 'Launched',
  pending: 'Pending',
  accepted: 'Accepted',
  rejected: 'Rejected',
  poster: 'Problem Poster',
  entrepreneur: 'Entrepreneur',
  investor: 'Investor',
  admin: 'Admin',
};

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  const classes = variantMap[variant] ?? 'bg-muted text-muted-foreground border-border';
  const text = label ?? labelMap[variant] ?? variant;
  return (
    <span
      className={`inline-flex items-center border rounded-full font-medium ${classes} ${
        size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1'
      }`}
    >
      {text}
    </span>
  );
}